if (typeof JW === 'undefined') JW = {};
JW.DateBook = (function ($)
{
    var _pri = {};
    var publ = {};
    var State;

    _pri.cname = 'XAP';
    _pri.opts = {

        dbg_lvl:        1,
        if_url:         '/_xap_if', // xap if
        enc:            false,      // url-encode form values
        dlm:            ',',        // value delimiter
        rx_fe_ds:       /^[0-3][0-9]\.[01][0-9]\.20[0-9]{2}$/,
        dp_opts: {
            autoclose:              false,
            calendarWeeks:          true,
            daysOfWeekHighlighted:  [0, 6],
            daysOfWeekDisabled:     [0, 6],
            format:                 'dd.mm.yyyy',
            language:               'de',
            todayBtn:               false,
            todayHighlight:         true,
            weekStart:              1,
            maxViewMode:            2,
            container:              '#wrp_cal',
            clsnms:                 'nai datebook w-100',
            templates: {
                leftArrow:  '<i class="fa fa-chevron-left"></i>',
                rightArrow: '<i class="fa fa-chevron-right"></i>'
            }
        }
    };

    _pri.uid         = '';
    _pri.$win        = $(window);
    _pri.xap_id      = '';
    _pri.scope       = '';
    _pri.form_data_1 = {};
    _pri.tab_next    = '';
    _pri.tab_1       = '';
    _pri.tabs        = ['00', '11', '12', '13', '20'];
    _pri.scopes      = ['01', '02', '03'];

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.init0 = function()
    {
        console.log('[' + _pri.cname + '] *** init0()');

        if (document.readyState === 'complete')
        {
            _pri.init1();
        }
        else
        {
            console.log('[' + _pri.cname + ']     listen to window load event ...');
            _pri.$win.on('load', _pri.init1);
        }
    };

    _pri.init1 = function()
    {
        _pri.extend();

        _pri.dbgG('*** init1()');

        if (_pri.inited)
        {
            _pri.dbgR('    !!! already inited!');
            return;
        }

        _pri.inited   = true;
        State         = JW.State;
        _pri.page     = JW.Page;
        _pri.modal    = JW.Modal;
        _pri.uid      = JW.Page.getUId();
        _pri.$doc     = $(document);

        $(document).on('click keyenter', '.tdact.tdbook',  _pri.onSlotClick);
        $(document).on('click keyenter', '.btn-xap-sub', _pri.onSubClick);
        $(document).on('click keyenter', '.btn-xap-bck',  _pri.onBckClick);
        $(document).on('click keyenter', '.mdl-close-xap',  _pri.onCloseXAp);

        if (typeof _pri.page.getState === 'function' && _pri.page.getState() == State.STATE_LOADED)
        {
            _pri.initXAp();
        }
        else
        {
            _pri.dbg('    listen for page:load_done ...');
            _pri.page.on('page:load_done', _pri.initXAp, 'page:load_done' + _pri.uid);
            _pri.page.on('xap:lsxap_on_load', _pri.initXAp, 'xap:lsxap_on_load' + _pri.uid);
        }
    }

    _pri.initXAp = function(e, o)
    {
        _pri.dbgG('*** initXAp()');

        _pri.page.off('page:load_done', _pri.initXAp, 'page:load_done' + _pri.uid);

        if (_pri.xap_id != '')
        {
            _pri.dbgR('    !!! still inited! ...');
            return;
        }

        _pri.$wrp_xap = $('#wrp_xap');

        if (_pri.$wrp_xap.length == 0)
        {
            _pri.dbg('    no wrp - return');
            return;
        }

        let conf = _pri.$wrp_xap.data('xap');
        if (!_pri.isObj(conf))
        {
            _pri.dbgR('!!! missing data-xap - return!');

            return;
        }

        _pri.updOpts(conf);

        // _pri.$cal = _pri.$wrp_xap.find('.datepicker.nai');
        //
        // if (_pri.$cal.length == 0)
        // {
        //     _pri.dbgR('!!! missing datepicker - return!');
        //     return;
        // }
        //
        // _pri.conf = _pri.$wrp_xap.data('datebook');
        // if (!_pri.isObj(_pri.conf))
        // {
        //     _pri.dbgR('!!! missing data-datebook - return!');
        //
        //     return;
        // }
        //
        // _pri.updOpts();
        //
        // let dp = _pri.$cal.datepicker(_pri.opts.dp_opts);
        //
        // dp.on('changeDate', _pri.onChangeDate);
        //
        // _pri.$cal.datepicker('setDate', _pri.opts.dp_opts.startDate);

        _pri.xap_id = _pri.page.getUId();

        _pri.$frm     = $('.xap-frm');

        _pri.$frm.submit(function(e) {
            e.stopPropagation();
            e.preventDefault();
            return false;
        });
    };

    _pri.setDay = function(day)
    {
        _pri.dbg('*** setDay() day:', day);

        if (_pri.day_cur != day && _pri.validDay(day))
        {
            _pri.day_cur = day;

            let cll = {
                _url:   _pri.opts.day_lst_url,
                _msk:   false,
                _dtp:   'JSON',
                _frmdt: {
                    act:     'get_slots',
                    fair_id: _pri.conf.fair_id,
                    ls_id:   _pri.conf.ls_id,
                    fe_ds:   _pri.day_cur
                }
            };

            _pri.modal.cll(cll, _pri.onSetDay);
        }
    };

    _pri.onSetDay = function(xhr)
    {
        _pri.dbgG('*** onSetDay() xhr:', xhr);

        var ret = JSON.parse(xhr.responseText);
        _pri.dbg('    ret json: ', ret, 'statusText: ', xhr.statusText);
        _pri.modal.handleJSONRet(ret, xhr.statusText, xhr);

        _pri.$wrp_lst = $('#wrp_lst');

        _pri.$wrp_lst.find('[data-toggle="tooltip"]').tooltip({
            html: true,
            // container: 'body',
            // trigger: 'click',
            trigger : 'hover',
            template: '<div class="tooltip nosel zix-mx" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-3 text-left"></div></div>',
            boundary: 'viewport'
        });


        let $first_act = $('.first_act');
        if ($first_act.length > 0)
        {
            _pri.$wrp_lst.animate({scrollTop: _pri.$wrp_lst.scrollTop() + ($('.first_act').offset().top - _pri.$wrp_lst.offset().top)});
        }
    };

    _pri.onSlotClick = function(e)
    {
        _pri.dbgY('*** onSlotClick() e:', e);

        if (_pri.xap_id == '')
        {
            _pri.dbg('    nope ...');
            return;
        }

        _pri.$wrp_lst.find('[data-toggle="tooltip"]').tooltip('dispose');

        let $this = $(this);
        _pri.tss  = $this.data('tss'); // time stamps start/end

        if (!_pri.isObj(_pri.tss))
        {
            return;
        }

        _pri.dbg('    tss:', _pri.tss);

        let cll = {
            _url:   _pri.opts.day_lst_url,
            _dtp:   'JSON',
            _frmdt: $.extend({
                act:     'get_frm',
                fair_id: _pri.conf.fair_id,
                ls_id:   _pri.conf.ls_id,
                fe_ds:   _pri.day_cur
            }, _pri.tss)
        };

        _pri.modal.cll(cll, _pri.onSetSlot);
    };

    _pri.onSetSlot = function(xhr)
    {
        _pri.dbgG('*** onSetSlot() xhr:', xhr);

        var ret = JSON.parse(xhr.responseText);
        _pri.dbg('    ret json: ', ret, 'statusText: ', xhr.statusText);
        _pri.modal.handleJSONRet(ret, xhr.statusText, xhr);

        _pri.modal.setMask(0, 0, 0);

        _pri.showFrm();
    };

    _pri.onSubSent = function(xhr)
    {
        _pri.dbgG('*** onSetSlot() xhr:', xhr);

        var ret = JSON.parse(xhr.responseText);
        _pri.dbg('    ret json: ', ret, 'statusText: ', xhr.statusText);
        _pri.modal.handleJSONRet(ret, xhr.statusText, xhr);

        _pri.modal.setMask(0, 0, 0);
    };

    _pri.onChangeDate = function(e)
    {
        // `e` here contains the extra attributes
        _pri.dbgY('*** onChangeDate() e:', e);

        _pri.dbg('    (getDate)', _pri.$cal.datepicker('getFormattedDate'));
        _pri.setDay(_pri.$cal.datepicker('getFormattedDate'));
    };

    _pri.showFrm = function()
    {
        _pri.$wrp_xap.addClass('d-none');
        _pri.$wrp_frm.css('opacity', 0);
        _pri.$wrp_frm.removeClass('d-none');
        _pri.$wrp_frm.animate({opacity: '1.0'}, 1000);
        let $inp_email = _pri.$wrp_frm.find('#email');
        if ($inp_email.length > 0)
        {
            $inp_email.focus();
        }
    };

    _pri.showMsg = function(str)
    {
        $('#xap_msgs').html('\
            <div class="text-left alert-danger fade show animated fadeIn">\
                <div class="con row py-3">\
                    <div class="col">\
                        <div class="msg-i fade show">\
                            <i class="fa fa-exclamation" aria-hidden="true"></i>\
                            <div>' + str + '</div>\
                        </div>\
                    </div>\
                </div>\
            </div>');
    };

    _pri.validateTab = function(tab, $tab)
    {
        _pri.dbgG('*** validateTab() tab:', tab);

        let state = State.STATE_OK;
        let scope, cll;

        if (!_pri.tabs.includes(tab))
        {
            _pri.dbgR('    !!! unknown tab:', tab, _pri.tabs);
            state = State.STATE_ERR;
        }

        if (state == State.STATE_OK)
        {
            switch (tab)
            {
                case '00':

                    _pri.dbg('    case 00:');

                    scope = _pri.$wrp_xap.find('input[name="scope"]:checked').val();
                    _pri.dbg('    scope:', scope);

                    if (_pri.scopes.includes(scope))
                    {
                        _pri.dbg('    scope found ...');
                        _pri.scope = scope;
                        _pri.tab_next = (10 + parseInt(_pri.scope)).toString();
                        _pri.tab_1    = _pri.tab_next;

                        _pri.tabValidated(tab, $tab);
                    }
                    else
                    {
                        _pri.tab_next = '';
                        state = State.STATE_ERR;
                        _pri.showMsg('Bitte wählen Sie einen Angebotsbereich aus.');
                    }

                break;

                case '11':
                case '12':
                case '13':

                    _pri.dbg('    case 11|12|13:');

                    _pri.sendFormData('tab1', function(xhr) {

                        _pri.dbgG('*** on tab1 response xhr:', xhr);

                        let ret = JSON.parse(xhr.responseText);
                        _pri.dbg('    ret json: ', ret, 'statusText: ', xhr.statusText);
                        _pri.modal.handleJSONRet(ret, xhr.statusText, xhr);

                        if (typeof ret === 'object' && typeof ret.state === 'object' && ret.state.state == 0)
                        {
                            _pri.dbg('    tab1 ok ...');
                            _pri.tab_next = '20';
                            _pri.tabValidated(tab, $tab);
                        }

                    });

                break;

                case '20':

                    _pri.dbg('    case 20:');

                    _pri.sendFormData('sub', function(xhr) {

                        _pri.dbgG('*** on sub response xhr:', xhr);

                        let ret = JSON.parse(xhr.responseText);
                        _pri.dbg('    ret json: ', ret, 'statusText: ', xhr.statusText);
                        _pri.modal.handleJSONRet(ret, xhr.statusText, xhr);

                        if (typeof ret === 'object' && typeof ret.state === 'object' && ret.state.state == 0)
                        {
                            _pri.dbg('    sub ok ...');
                            _pri.tab_next = '30';
                            _pri.tabValidated(tab, $tab);

                        }
                    });

                    // _pri.form_data_1 = $.extend({}, form_data);

                break;

                default:

                break;
            }
        }
    };

    _pri.onSubClick = function(e)
    {
        _pri.dbgG('*** onSubClick()');

        if (_pri.xap_id == '')
        {
            _pri.dbg('    nope ...');
            return;
        }

        let $this = $(this);
        let $tab  = $this.closest('.xap-tab');
        let tab   = $tab.data('tab');

        _pri.dbg('    tab:', tab);
        if (typeof tab === 'undefined')
        {
            return false;
        }
        else if (typeof tab !== 'string')
        {
            tab = tab.toString();
        }

        if ($tab.length < 1)
        {
            _pri.dbgR('    !!! no tab obj!');
            return false;
        }

        _pri.validateTab(tab, $tab);


        // let frmdt = {
        //     act:        'sub_frm',
        //     fair_id:    _pri.conf.fair_id,
        //     ls_id:      _pri.conf.ls_id,
        //     fe_ds:      _pri.day_cur,
        //     email:      $('#email').val(),
        //     email2:     $('#email2').val(),
        //     captcha:    $('#captcha').val()
        // };
        //
        // let cll = {
        //     _url:   _pri.opts.day_lst_url,
        //     _dtp:   'JSON',
        //     _frmdt: $.extend(frmdt, _pri.tss)
        // };
        //
        // _pri.modal.cll(cll, _pri.onSubSent);
    };

    _pri.tabValidated = function(tab, $tab)
    {
        _pri.dbg('    validated ...');
        _pri.dbg('    tab_next:', _pri.tab_next);

        if (_pri.tab_next != '')
        {
            $tab.addClass('d-none');
            _pri.showTab(_pri.tab_next);
        }
    };

    _pri.showTab = function(tab)
    {
        _pri.dbgG('*** showTab() tab:', tab);

        $('.xap-tab').addClass('d-none');
        $('#xap_tab_' + tab).removeClass('d-none');

        if (tab == '11' || tab == '12' || tab == '13')
        {
            $('#xap_msgs').html('');
            $('#xap_step_1').removeClass('bg-100').addClass('bg-primary');
            $('#xap_step_2').removeClass('bg-primary').addClass('bg-100');
            $('#xap_step_3').removeClass('bg-primary').addClass('bg-100');
        }
        else if (tab == '20')
        {
            $('#xap_step_1').removeClass('bg-100').addClass('bg-primary');
            $('#xap_step_2').removeClass('bg-100').addClass('bg-primary');
            $('#xap_step_3').removeClass('bg-primary').addClass('bg-100');
        }
        else if (tab == '30')
        {
            $('#xap_step_1').removeClass('bg-100').addClass('bg-primary');
            $('#xap_step_2').removeClass('bg-100').addClass('bg-primary');
            $('#xap_step_3').removeClass('bg-100').addClass('bg-primary');
        }
        else
        {
            $('#xap_msgs').html('');
            $('#xap_step_1').removeClass('bg-primary').addClass('bg-100');
            $('#xap_step_2').removeClass('bg-primary').addClass('bg-100');
            $('#xap_step_3').removeClass('bg-primary').addClass('bg-100');
        }
    };

    _pri.onBckClick = function(e)
    {
        _pri.dbgG('*** onBckClick()');

        if (_pri.xap_id == '')
        {
            _pri.dbg('    nope ...');
            return;
        }

        let $this = $(this);
        let $tab  = $this.closest('.xap-tab');
        let tab   = $tab.data('tab');

        if (tab == '11' || tab == '12' || tab == '13')
        {
            _pri.dbg('    to 00');
            $tab.addClass('d-none');
            _pri.showTab('00');
        }
        else if (tab == '20')
        {
            _pri.dbg('    to tab_1', _pri.tab_1);
            $tab.addClass('d-none');
            _pri.showTab(_pri.tab_1);
        }
    };

    _pri.sendFormData = function(act, cb)
    {
        _pri.dbgG('*** sendFormData()');

        let arr = _pri.$frm.serializeArray();
        _pri.dbg('    arr:', arr);

        let form_data =
        {
            fair_id: _pri.opts.fair_id,
            ls_id: _pri.opts.ls_id,
            scope: _pri.scope,
            act: act
        };
        let len = arr.length;
        let i, o, val;
        for (i = 0; i < len; ++i)
        {
            o = arr[i];

            if (!_pri.opts.enc)
            {
                val = o.value.toString();
            }
            else
            {
                // val = encodeURIComponent(o.value.toString());
                val = _pri.rawurlencode(o.value.toString());
            }

            if (!form_data.hasOwnProperty(o.name))
            {
                form_data[o.name] = val;
            }
            else
            {
                form_data[o.name] += _pri.opts.dlm + val;
            }
        }

        let cll = {
            _url:   _pri.opts.if_url,
            _msk:   false,
            _dtp:   'JSON',
            _frmdt: form_data
        };

        _pri.modal.cll(cll, cb);
    };

    _pri.updOpts = function(conf)
    {
        _pri.dbgG('*** updOpts()', conf);

        _pri.opts = $.extend(_pri.opts, conf);
    };

    _pri.validDay = function(day)
    {
        return (typeof day === 'string' && _pri.opts.rx_fe_ds.test(day));
    };

    _pri.onCloseXAp = function()
    {
        _pri.xap_id = '';

        let ret = {
            msk: [0, 0, 0, -1],
            mdlc: true
        };
        _pri.modal.handleJSONRet(ret);
    };

    // _pri.extend();
    _pri.init0();
    // expose public methods
    return publ;
})(jQuery);